import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthContext from './AuthContext';
import { LanguageContext } from './LanguageContext';

const AuthGuard = ({ children }) => {
  const { isAuthenticated, loading, authorizationError } = useContext(AuthContext);
  const { language } = useContext(LanguageContext) || { language: 'en' };
  const location = useLocation();

  if (loading) {
    return <div style={{ textAlign: 'center', marginTop: '2rem' }}>Loading...</div>;
  }

  if (authorizationError === 'applicant_account_required') {
    return (
      <main className="govuk-width-container govuk-main-wrapper" role="main">
        <div className="govuk-error-summary" role="alert">
          <h1 className="govuk-error-summary__title">
            {language === 'fr'
              ? 'Cette section nécessite un compte du portail des demandeurs.'
              : 'This area requires an applicant portal account.'}
          </h1>
          <div className="govuk-error-summary__body">
            <a className="govuk-link" href="/sign-out">
              {language === 'fr' ? 'Se déconnecter' : 'Sign out'}
            </a>
          </div>
        </div>
      </main>
    );
  }

  if (!isAuthenticated) {
    // Pass the intended program + original target path to login page
    const program =
      location.pathname === '/iset-wizard'
        ? 'DynamicTest'
        : location.pathname.startsWith('/jordan')
        ? 'Jordan'
        : 'ISET';
    const from = location.pathname + (location.search || '') + (location.hash || '');
    return <Navigate to="/login" replace state={{ program, from }} />;
  }

  return children;
};

export default AuthGuard;
